export enum ServiceTypeEnum {
  VIDEO = 'videos',
  CONSULTANCY = 'consultations'
}
